import React from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import styled from 'styled-components';
import Login from './Pages/Login';
import OTPPage from './Pages/OTPPage';
import SuccessPage from './Pages/SuccessPage';
import RegisterStep1 from './Pages/register/re-1';
import RegisterStep2 from './Pages/register/re-2';
import RegisterStep3 from './Pages/register/re-3';
import WelcomePage from './Pages/WelcomePage';
import DailyHealthRecord from './Pages/DailyHealthRecord';
import DashboardPage from './Pages/DashboardPage'
import VaccineNotificationPage from './Pages/VaccineNotificationPage';
import BloodPressurePage from './Pages/BloodPressurePage';
import TestResultsPage from './Pages/TestResultsPage';
import ComparisonResultsPage from './Pages/ComparisonResultsPage';
import HospitalCheckupForm from './Pages/HospitalCheckupForm';
import ProfileEditPage from './Pages/ProfileEditPage';
import RecommendationsPage from './Pages/RecommendationsPage';
import NotificationsPage from './Pages/NotificationsPage';
import XrayResultsPage from './Pages/XrayResultsPage';

const AppContainer = styled.div`
  min-height: 100vh;
  font-family: 'Noto Sans Thai', sans-serif !important;
  font-weight: bold;
  background-color: white;
  * {
    font-family: 'Noto Sans Thai', sans-serif !important;
    font-weight: bold;
  }
`;

const router = createBrowserRouter([
  {
    path: "/",
    element: <Login />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/otp",
    element: <OTPPage />,
  },
  {
    path: "/success",
    element: <SuccessPage />,
  },
  {
    path: "/register",
    element: <RegisterStep1 />,
  },
  {
    path: "/register/step1",
    element: <RegisterStep1 />,
  },
  {
    path: "/register/step2",
    element: <RegisterStep2 />,
  },
  {
    path: "/register/step3",
    element: <RegisterStep3 />,
  },
  {
    path: "/welcome",
    element: <WelcomePage />,
  },
  {
    path: "/daily-health-record",
    element: <DailyHealthRecord />,
  },
  {
    path: "/dashboard",
    element: <DashboardPage />,
  },
  {
    path: "/vaccine-notification",
    element: <VaccineNotificationPage />,
  },
  {
    path: "/blood-pressure",
    element: <BloodPressurePage />,
  },
  {
    path: "/test-results",
    element: <TestResultsPage />,
  },
  {
    path: "/comparison-results",
    element: <ComparisonResultsPage />,
  },
  {
    path: "/hospital-checkup",
    element: <HospitalCheckupForm />,
  },
  {
    path: "/profile-edit",
    element: <ProfileEditPage />,
  },
  {
    path: "/recommendations",
    element: <RecommendationsPage />,
  },
  {
    path: "/notifications",
    element: <NotificationsPage />,
  },
  {
    path: "/xray-results",
    element: <XrayResultsPage />,
  }
]);

function App() {
  return (
    <AppContainer>
      <RouterProvider router={router} />
    </AppContainer>
  );
}

export default App;